import { getUserAccountTokens } from '../../api/api';

export const useRedirectToAccount = () => {
  const redirectToUserAccount = (data) => {
    const query = new URLSearchParams(data).toString();

    const url = `${process.env.REACT_APP_CLIENT_URL}?${query}`;
    window.open(url, '_blank');
  };

  const handleSwitchToUserAccount = async (userId) => {
    if (userId) {
      await getUserAccountTokens(userId, redirectToUserAccount);
    }
  };

  return { handleSwitchToUserAccount };
};
